import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SVG, Path, Rect } from '@wordpress/primitives';
var queryPaginationNext = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Rect, {
  x: "6",
  y: "10.5",
  width: "3",
  height: "3",
  rx: "1.5",
  fill: "#000"
}), createElement(Rect, {
  x: "11",
  y: "10.5",
  width: "3",
  height: "3",
  rx: "1.5",
  fill: "#000"
}), createElement(Path, {
  d: "M16.5 9.5L19 12l-2.5 2.5",
  stroke: "#1E1E1E",
  strokeWidth: "1.5"
}));
export default queryPaginationNext;
//# sourceMappingURL=query-pagination-next.js.map